"use strict";
import Tribute from "src/decidim/vendor/tribute";
const mentionsInitializer = () => {
  const $mentionContainer = $(".js-mentions");
  const nodatafound = $mentionContainer.attr("data-noresults");
  if ($mentionContainer.parent().hasClass("editor")) {
    return;
  }
  let noMatchTemplate = null;
  if (nodatafound) {
    noMatchTemplate = () => `<li>${nodatafound}</li>`;
  }
  const debounce = function(callback, wait) {
    let timeout = null;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => callback.apply(context, args), wait);
    };
  };
  let remoteSearch = function(text, cb) {
    let query = `{users(filter:{wildcard:"${text}"}){nickname,name,avatarUrl,__typename,...on UserGroup{membersCount}}}`;
    $.post(window.Decidim.config.get("api_path"), { query }).then((response) => {
      let data = response.data.users || {};
      cb(data);
    }).fail(function() {
      cb([]);
    }).always(() => {
      const $parent = $(tribute.current.element).parent();
      $parent.addClass("is-active");
      const $tribute = $parent.find(".tribute-container");
      $tribute.removeAttr("style");
    });
  };
  let tribute = new Tribute({
    trigger: "@",
    // avoid overloading the API if the user types too fast
    values: debounce(function(text, cb) {
      remoteSearch(text, (users) => cb(users));
    }, 250),
    positionMenu: true,
    menuContainer: null,
    allowSpaces: true,
    menuItemLimit: 5,
    fillAttr: "nickname",
    selectClass: "highlight",
    noMatchTemplate,
    lookup: (item) => item.nickname + item.name,
    selectTemplate: function(item) {
      if (typeof item === "undefined") {
        return null;
      }
      return item.original.nickname;
    },
    menuItemTemplate: function(item) {
      let svg = "";
      if (window.Decidim && item.original.__typename === "UserGroup") {
        const iconsPath = window.Decidim.config.get("icons_path");
        svg = `<span class="is-group">${item.original.membersCount}x <svg class="icon--members icon"><use href="${iconsPath}#ri-team-line"/></svg></span>`;
      }
      return `
        <img src="${item.original.avatarUrl}" alt="author-avatar">
        <strong>${item.original.nickname}</strong>
        <small>${item.original.name}</small>
        ${svg}
      `;
    }
  });
  let setupEvents = function($element) {
    $element.on("focusin", (event) => {
      tribute.menuContainer = event.target.parentNode;
    });
    $element.on("focusout", (event) => {
      let $parent = $(event.target).parent();
      if ($parent.hasClass("is-active")) {
        $parent.removeClass("is-active");
      }
    });
    $element.on("input", (event) => {
      let $parent = $(event.target).parent();
      if (tribute.isActive) {
        let $tribute = $(".tribute-container");
        $tribute.appendTo($parent);
        $parent.addClass("is-active");
      } else {
        $parent.removeClass("is-active");
      }
    });
  };
  setupEvents($mentionContainer);
  $(document).on("attach-mentions-element", (event, element) => {
    if (!element) {
      return;
    }
    tribute.attach(element);
    if (tribute.menu && !document.body.contains(tribute.menu)) {
      tribute.range.getDocument().body.appendChild(tribute.menu);
    }
    setupEvents($(element));
  });
  tribute.attach($mentionContainer);
};
$(() => mentionsInitializer());
